export default {"src":"/_next/static/media/buildings.1c022b29.svg","height":40,"width":40};